/**
 * Route for `igaming-player-registration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingPlayerRegistrationPage } from "../features/igaming-player-registration/IgamingPlayerRegistrationPage";

export const igamingPlayerRegistrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-player-registration",
	component: IgamingPlayerRegistrationPage,
});

export default igamingPlayerRegistrationRoute;
